import React from "react";
import { Button, Space, Typography } from "antd";
import { FaUsers } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";
import { useCan } from "../../../utils/permissions";

const { Title } = Typography;

const UserHeader = ({ 
  searchData, 
  setSearchData, 
  handleSearchInput, 
  loading, 
  handleRefresh
}) => {
  const can = useCan();
  const canRead = can("audit", "read") || true;
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <Title level={2} style={{ margin: 0 }}>
        <FaUsers style={{ marginRight: '10px' }} />
        Audit Logs
      </Title>
      <Space>
        <div className="position-relative">
          <input
            type="search"
            className="search-input form-control"
            placeholder="Search Logs"
            value={searchData}
            onChange={handleSearchInput}
            disabled={!canRead}
          />
          <IoIosSearch className={`icon-cls ${searchData ? 'search-icon-hidden' : ''}`} />
        </div>
        <Button
          onClick={handleRefresh}
          loading={loading}
          style={{ marginRight: '8px' }}
          disabled={!canRead}
        >
          Refresh Data
        </Button>
      </Space>
    </div>
  );
};

export default UserHeader;
